export const featuredPortfolio = [
    {
      id: 1,
      title: "Social Media App",
      img:
        "https://cdn.pixabay.com/photo/2020/05/18/16/17/social-media-5187243_960_720.png",
    },
    {
      id: 2,
      title: "UI Design",
      img:
        "https://cdn.pixabay.com/photo/2016/09/08/17/46/user-interface-1655006_960_720.png",
    },
    {
      id: 3,
      title: "E-commerce Web Design",
      img:
        "https://cdn.pixabay.com/photo/2019/04/26/07/14/store-4156934_960_720.png",
    }
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Web Social Media App",
      img: "https://cdn.pixabay.com/photo/2020/05/18/16/17/social-media-5187243_960_720.png",
    },
    {
      id: 2,
      title: "Web UI Design",
      img: "https://cdn.pixabay.com/photo/2016/09/08/17/46/user-interface-1655006_960_720.png",
    },
    {
      id: 3,
      title: "Web E-commerce Design",
      img: "https://cdn.pixabay.com/photo/2019/04/26/07/14/store-4156934_960_720.png",
    }
  ];
  
